module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIyNyIgdmlld0JveD0iMCAwIDMwMSAyMjciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjQzYwQzMwIiBkPSJNLjUuNWgzMDB2MjI2SC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik05Ni43OTEuNWgzMi4zNTR2MjI2SDk2Ljc5MXoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMzAwLjUgOTcuMzIzdjMyLjM1NEguNVY5Ny4zMjN6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-dk.svg
// module id = IKrb
// module chunks = 2